module.exports = __webpack_public_path__ + "static/media/DoesntMatter.d79b6daf.png";